import React from 'react';
import PropTypes from 'prop-types';
import s from './MessageBanner.module.css';

const MessageBanner = ({ color, message, testId }) => {
  let barColorStyleClass = '';

  switch (color) {
    case 'blue':
      barColorStyleClass = s.blueBar;
      break;
    case 'purple':
      barColorStyleClass = s.purpleBar;
      break;
    case 'restricted':
      barColorStyleClass = s.restrictedBar;
      break;
    default:
      barColorStyleClass = s.blueBar;
      break;
  }

  return (
    <div
      className={`${s.messageBar} ${barColorStyleClass}`}
      data-test-id={testId}
    >
      <div className={s.content}>{message}</div>
    </div>
  );
};

MessageBanner.propTypes = {
  color: PropTypes.string,
  message: PropTypes.string,
  testId: PropTypes.string,
};

export default MessageBanner;
